.weight400 {
  font-weight: 400 !important;
}
.weight500 {
  font-weight: 500 !important;
}
.weight600 {
  font-weight: 600 !important;
}
.noMargin {
  margin: 0 !important;
}
